import yoproducts from '@yola/yoproductsjs';
import get from 'lodash.get';
import configStorage from '../../configuration/config-storage';

let serviceClient;

export default {
  get(isB2C = true) {
    if (!serviceClient) {
      const { commonConfig } = configStorage.get();
      const apiUrl = get(commonConfig, `public-api-gateway.${isB2C ? 'url' : 'wl_url'}`, '');

      serviceClient = {
        actions: yoproducts.actions,
        requests: yoproducts.initRequests(apiUrl),
      };
    }

    return serviceClient;
  },
};
